import { render } from "./UserManagementPage.vue?vue&type=template&id=0d7a49e7"
import script from "./UserManagementPage.vue?vue&type=script&lang=js"
export * from "./UserManagementPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__